import { render, staticRenderFns } from "./UserClient.vue?vue&type=template&id=1e0d7c46&"
import script from "./UserClient.vue?vue&type=script&lang=js&"
export * from "./UserClient.vue?vue&type=script&lang=js&"
import style0 from "./UserClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports